import { render, staticRenderFns } from "./LicencesTab.vue?vue&type=template&id=01d42e96&scoped=true&"
import script from "./LicencesTab.vue?vue&type=script&lang=js&"
export * from "./LicencesTab.vue?vue&type=script&lang=js&"
import style0 from "./LicencesTab.vue?vue&type=style&index=0&id=01d42e96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d42e96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VRow,VTextField})
